<template>
  <form class="kompa-cameras-form uk-form-stacked" @submit.prevent="submit">
   <checkbox
          :disabled="!isEditable"
          :errors="form.errors.indoor"
          :label="$t('fields.indoor')"

          ref="indoor"
          v-model="form.model.indoor"
        />
   <checkbox
          :disabled="!isEditable"
          :errors="form.errors.outdoor"
          :label="$t('fields.outdoor')"

          ref="outdoor"
          v-model="form.model.outdoor"
        />
   <checkbox
          :disabled="!isEditable"
          :errors="form.errors.personRecognition"
          :label="$t('fields.personRecognition')"

          ref="personRecognition"
          v-model="form.model.personRecognition"
        />
   <checkbox
          :disabled="!isEditable"
          :errors="form.errors.cloudData"
          :label="$t('fields.cloudData')"

          ref="cloudData"
          v-model="form.model.cloudData"
        />
   <checkbox
          :disabled="!isEditable"
          :errors="form.errors.magentaCloudData"
          :label="$t('fields.magentaCloudData')"

          ref="magentaCloudData"
          v-model="form.model.magentaCloudData"
        />
   <checkbox
          :disabled="!isEditable"
          :errors="form.errors.sdMemoryCard"
          :label="$t('fields.sdMemoryCard')"

          ref="sdMemoryCard"
          v-model="form.model.sdMemoryCard"
        />
   <checkbox
          :disabled="!isEditable"
          :errors="form.errors.streamingOnly"
          :label="$t('fields.streamingOnly')"

          ref="streamingOnly"
          v-model="form.model.streamingOnly"
        />
   <checkbox
          :disabled="!isEditable"
          :errors="form.errors.microphone"
          :label="$t('fields.microphone')"

          ref="microphone"
          v-model="form.model.microphone"
        />
    <checkbox
          :disabled="!isEditable"
          :errors="form.errors.sdBuffered"
          :label="$t('fields.sdBuffered')"

          ref="sdBuffered"
          v-model="form.model.sdBuffered"
        />

    <submit-button type="primary" :disabled="!isSubmittable" />
    <cancel-button />


  </form>
</template>

<script>
import Form from '@/mixins/LegacyForm';
import KeywordListInput from '@/components/KeywordListInput';
import Checkbox from '@/components/Checkbox';

export default {
  name: 'kompa-cameras-form',
  components: {
    KeywordListInput,
    Checkbox,
  },
  mixins: [
    Form({
      indoor: { required: false },
      outdoor: { required: false },
      personRecognition: { required: false },
      cloudData: { required: false },
      magentaCloudData: { required: false },
      sdMemoryCard: { required: false },
      streamingOnly: { required: false },
      microphone: { required: false },
      sdBuffered: { required: false },
    }),
  ],
  mounted() {
    this.$refs.indoor.focus();
  },
};
</script>



// WEBPACK FOOTER //
// KompaCamerasForm.vue?1e4a4496